import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const OrgPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OrgPageContainer" */
      './OrgPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
